import { putWithToken } from 'api/network';
import { put, takeEvery, select } from 'redux-saga/effects';
import {
  appNotify,
  updateAssumptionModule,
  setModulesAreLoading,
  setSelectedModule,
  fetchAssumptionModules
} from '../../../store/actions';
import { selectedModuleSelector } from 'store/selectors';

export function* updateAssumptionModuleSaga() {
  yield takeEvery(updateAssumptionModule, function* ({ payload }) {
    try {
      yield put(setModulesAreLoading(true));
      const url = '/api/assumptions/modules';
      yield putWithToken(url, payload);
      yield put(fetchAssumptionModules());
      const selectedModule = yield select(selectedModuleSelector);
      if (payload.moduleId === selectedModule?.moduleId) { // If saga is being called by editing a module description from the Manager list, id may not equal selectedModule.id so don't update
        yield put(setSelectedModule(payload));
      }
      yield put(setModulesAreLoading(false));
      yield put(appNotify(`${payload.name} updated`, 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to update assumption module: ${error.message}`, 'error')
      );
      yield put(setModulesAreLoading(false));
    }
  });
}
